// extracted by mini-css-extract-plugin
export default {"root_scroller":"KU","flex_container":"LU","container":"MU","scroller":"NU","indicator":"OU","scrollButtons":"PU","selected":"QU","root_tab":"RU","root_tab_scrollable":"SU","root_scroller_mob":"TU","scroller_mob":"UU","indicator_mob":"VU","selected_mob":"WU","root_tab_mob":"XU","root_tab_mob_scrollable":"YU"};
    if(module.hot) {
      // 1713996749557
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  